import React from 'react';
import './LoaderStyle.css';
import ForkLift from './forklift.svg'
import Boat from './cargo-ship.svg'

export function LoaderOne() {
    return (
        <div>
            <div className="spinner">
                <img src={ForkLift} className="forklift" alt="ForkLift" />
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
                <span id="dash">
                    <br />
                </span>
            </div>

        </div>
    );
}

export function LoaderTwo() {
    return (
        <div className="load2">
            <img src={Boat} className="Boat" alt="Boat" />
            <div className="cargo1"></div>
            <div className="cargo2"></div>
            <div className="cargo3"></div>
            <span className="bubble"></span>
        </div>
    );
}

export function LoaderThree() {
    return (
        <div className="">
            <div className=""></div>
            <div className=""></div>
            <div className=""></div>
        </div>
    );
}